import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'
import { RANDOM_TASK_QUERY_KEY } from '../../tasks/useGetRandomTask'
import { PIPELINE_QUERY_KEY } from './useGetPipeline'

type PipelineMediaManagementPayload = {
  loadAllMedia: boolean
  expectedMediaMinimumCount: number
  expectedMediaMaximumCount: number
  taskLevelActions: boolean
  showPlaybackControls: boolean
  isOverlayApplied: boolean
  overlays?: {
    pipelineJobOverlayId?: string
    pipelineJobId: string
    mediaId: string
    cameraName: string
    vehicleType: string
  }[]
}

export const useEditTaskMediaManagement = (programId: string, jobId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: PipelineMediaManagementPayload) => {
      const { data } = await apiClient.put(
        `/int/v3/programs/${programId}/pipeline/jobs/${jobId}/media`,
        payload
      )
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PIPELINE_QUERY_KEY] })
      queryClient.invalidateQueries({ queryKey: [RANDOM_TASK_QUERY_KEY] })
    },
  })
}
